import { RegistrationService } from './../../core/service/registration.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { MemberListService } from '../../core/service/grid-data/grid-data-member.service';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { State } from '@progress/kendo-data-query';
import { Subscription } from 'rxjs';
import
{
  GridDataResult, DataStateChangeEvent, ColumnVisibilityChangeEvent, ColumnReorderEvent,
  GridComponent
} from '@progress/kendo-angular-grid';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { AppConfigService } from 'src/app/core/service/app-config.service';
import { SearchHelperService } from 'src/app/core/utility/search-helper.service';
import { ActivatedRoute } from '@angular/router';
import { FilterService } from 'src/app/core/filter/filter.service';
import { SettingService } from 'src/app/core/service/setting.service';
import { Filter } from 'src/app/core/filter/filter';
import { IntlService } from '@progress/kendo-angular-intl';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { UserService } from 'src/app/core/service/user.service';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { ColumnSettings } from 'src/app/core/model/column-settings';
import { cloneDeep } from 'lodash';
import { GridResizeEvent } from 'src/app/core/model/grid-settings';
import { FhirService, FHIR_NAVIGATE_TO_PATIENT_SUMMARY } from 'src/app/core/service/fhir.service';
import { SessionStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.scss']
})

export class MemberListComponent implements OnInit, OnDestroy
{
  @ViewChild(GridComponent) public grid: GridComponent;

  public autoFitColumnsEnabled = false;
  public username = this.authenticationService.isAuthenticated ? this.authenticationService.currentUser.userName : null;
  public currentUser = this.authenticationService.currentUser;
  public breadcrumb = 'ALL';
  public enableAdvanced = false;
  public state: State = {
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  public isRestrictedPaging = false;
  public pageSizes = [5, 10, 25, 50, 100];
  public gridView: GridDataResult;
  public gridData: any = {};
  public total: number;
  public defaultGridState = null;
  public defaultColumnsConfig: ColumnSettings[];
  public columnsConfig: ColumnSettings[];

  public memberDialogOpened = false;
  public filterText = '';
  public genders = [];
  public gender = null;
  public filterDialogOpened = false;
  public stringLiteralBreadcrumb = false;

  public patientLabel = {};
  public patientLabelText = '';

  /**
   * Subscription to Angular component route parameters.
   */
  public routeParamSubscription: Subscription;

  public filterSelected: Filter;
  public communityEnabled = false;
  public communityPortalEnabled = false;
  public insurancesEnabled = false;
  public memberSelected: any;
  public openSendMethodDialog = false;
  public sendMethodType = '';
  public textBY = '';
  public searchControl = new UntypedFormControl();
  public isRecentViewContext = false;
  public subjectIdentifierMPI = null;

  private listSubscription: Subscription;

  constructor(
    private authenticationService: AuthenticationService,
    private memberListService: MemberListService,
    private dictionaryService: DictionaryService,
    private service: MemberListService,
    private route: ActivatedRoute,
    private filterService: FilterService,
    private appConfigService: AppConfigService,
    private searchHelperService: SearchHelperService,
    private settingService: SettingService,
    private messageHandlerService: MessageHandlerService,
    private translate: TranslateService,
    private registrationService: RegistrationService,
    private userService: UserService,
    public intl: IntlService,
    private sessionStorageService: SessionStorageService,
    private fhirService: FhirService,
    private router: Router,)
  {
    this.state.take = this.appConfigService.getConfig().pageSize;
    if (this.fhirService.navigateToPatientSummary)
    {
      this.dictionaryService.getCachedIdentifiers().subscribe({
        next: (data) =>
        {
          this.subjectIdentifierMPI = data.find(x => x.code.toLowerCase() === 'mpi');
          this.navigateToPatientFHIRFullSite();
        }
      });
    }
  }

  /**
   * Provide loading property from Service.
   */
  public get loading(): boolean
  {
    return this.memberListService.loading;
  }

  public ngOnInit(): void
  {
    this.getGenderCodes();
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.isRestrictedPaging = sessionSetting.pagingRestrictionPatientEnabled &&
          (this.currentUser.role === 'ROLE_PROGRAM_LEAD' || this.currentUser.role === 'ROLE_CARE_COORDINATOR' || this.currentUser.role === 'ROLE_COMMUNITY_COORDINATOR');
        this.autoFitColumnsEnabled = sessionSetting.autofitGridColumnsPatient;
        this.patientLabel = { patientLabel: sessionSetting.patientLabel };
        this.patientLabelText = sessionSetting.patientLabel;
        this.communityEnabled = sessionSetting.communityEnabled;
        this.communityPortalEnabled = sessionSetting.communityPortalEnabled;
        this.insurancesEnabled = (sessionSetting.insurancesRoles !== '') ?
          this.userService.isRoleInList(this.authenticationService.currentUser.role, sessionSetting.insurancesRoles) : false;

        this.filterService.getFilter(sessionSetting.defaultGridFilterPatient).subscribe({
          next: (data: Filter) =>
          {
            this.memberListService.setDefaultColumnsSetting(data?.state ? data.state : '', data?.columns ? data.columns : '',
              this.appConfigService.getConfig().pageSize, this.patientLabelText,
              this.insurancesEnabled, (this.communityEnabled && this.communityPortalEnabled)).then((config: any) =>
              {
                // Keeping default grid state and column config
                this.defaultGridState = cloneDeep(config.state);
                this.defaultColumnsConfig = cloneDeep(config.columns);

                // Current grid state and column config
                this.state = cloneDeep(config.state);
                this.columnsConfig = cloneDeep(config.columns);

                this.routeParamSubscription = this.route.params.subscribe({
                  next: (params) =>
                  {
                    this.filterSelected = undefined;
                    this.getMembers(params.filter);
                  }
                });
              });
          }
        });
      }
    });

    this.searchControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe({
        next: (searchValue: string) =>
        {
          this.searchFieldChange(searchValue);
        }
      });

    this.translate.get(['BY']).subscribe({
      next: (res) =>
      {
        this.textBY = res.BY.toLowerCase();
      }
    });

    this.listSubscription = this.memberListService.subscribe({
      next: (value) =>
      {
        if (value !== null && value.data !== null)
        {
          value.data.forEach(v =>
          {
            if (v.dateOfBirth !== null && v.dateOfBirth !== undefined && v.dateOfBirth.length === 10)
            {
              v.dateOfBirth = new Date(`${v.dateOfBirth}T12:00:00.000`);
            }
            if (v.inviteSentOrRegisteredDate !== null)
            {
              v.inviteSentOrRegisteredDate = new Date(v.inviteSentOrRegisteredDate);
            }
            if (v.spokenLanguages !== null && v.spokenLanguages.length > 0 && v.spokenLanguages.map !== undefined)
            {
              v.spokenLanguages = v.spokenLanguages !== null ? v.spokenLanguages.map(x => x.displayName).join(', ') : '';
            }
            else
            {
              v.spokenLanguages = '';
            }
          });
        }
        this.gridView = {
          data: (value) ? this.gridData = value.data : this.gridData = [],
          total: (value) ? this.total = value.total : this.total = 0
        };
        this.autoFitColumns();
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.routeParamSubscription !== undefined) { this.routeParamSubscription.unsubscribe(); }
    if (this.listSubscription !== undefined) { this.listSubscription.unsubscribe(); }
  }

  /**
   * Data change event handler.
   *
   * @param state State of grid operations
   */
  public dataStateChange(state: DataStateChangeEvent): void
  {
    this.state = state;
    this.queryMembers(this.service, state);
  }

  public onMemberAdded(): void
  {
    this.memberDialogOpened = false;
    this.queryMembers(this.memberListService, this.state);
  }

  public onMemberApplied(): void
  {
    this.queryMembers(this.memberListService, this.state);
  }

  /**
   * Filtering by search field
   */
  public filterChange(filter: CompositeFilterDescriptor): void
  {
    this.state.filter = filter;
    this.queryMembers(this.service, this.state);
  }

  public searchFieldChange(filterText: string): void
  {
    this.state.skip = 0;
    const isNumericCaseNumber = /^-?\d+$/.test(filterText);
    const field = isNumericCaseNumber ? 'id' : 'fullName';
    const operator = isNumericCaseNumber ? 'eq' : 'contains';
    const filterValue = isNumericCaseNumber ? parseInt(filterText, 10) : filterText;
    // Clear any preceeding id or name filter
    if (this.state.filter && this.state.filter.filters)
    {
      let index = this.state.filter.filters.findIndex((obj: any) => obj.field === 'id');
      if (index !== -1)
      {
        this.state.filter.filters.splice(index, 1);
      }
      index = this.state.filter.filters.findIndex((obj: any) => obj.field === 'fullName');
      if (index !== -1)
      {
        this.state.filter.filters.splice(index, 1);
      }
    }
    const filters = this.searchHelperService.fieldChange(filterValue, this.state, field, operator);
    this.filterText = filterText;
    this.filterChange(filters);
  }

  public openMethodDialog(member: any, type: string): void
  {
    this.sendMethodType = type;
    this.memberSelected = member;

    const noCell = !(this.memberSelected.cellPhoneNumber !== null && this.memberSelected.cellPhoneNumber !== '');
    const noEmail = !(this.memberSelected.email !== null && this.memberSelected.email !== '');

    if (noCell && noEmail)
    {
      this.messageHandlerService.displayError('NO-CELL-PHONE-EMAIL-ERROR');
    }
    else if (noEmail && type === 'INVITE')
    {
      this.messageHandlerService.displayError('COMMUNITY-INVITE-EMAIL-REQUIRED');
    }
    else
    {
      if (type === 'INVITE')
      {
        this.registrationService.emailExists(this.memberSelected.email).subscribe({
          next: (response) =>
          {
            if (response)
            {
              this.messageHandlerService.displayError('EMAIL-ALREADY-REGISTERED');
            }
            else
            {
              this.openSendMethodDialog = true;
            }
          }
        });
      }
      else
      {
        this.openSendMethodDialog = true;
      }
    }
  }

  public closeSendMethod(refreshList: boolean): void
  {
    if (refreshList)
    {
      this.queryMembers(this.memberListService, this.state);
    }
    this.openSendMethodDialog = false;
  }

  public getInviteFromOrganizationName(member: any): string
  {
    if (member && member.inviteOrganizationName)
    {
      return `${this.textBY} ${member.inviteOrganizationName}`;
    }
    else
    {
      return '';
    }
  }

  /**
   * Grid column visibility changed.
   *
   * @param event Grid column visibility event.
   */
  public onVisibilityChange(event: ColumnVisibilityChangeEvent): void
  {
    event.columns.forEach((column: any) =>
    {
      const field = this.columnsConfig.find((col) => col.field === column.field);
      if (field !== undefined)
      {
        field.hidden = column.hidden;
      }
    });
  }

  /**
   * Grid onResize event.
   *
   * @param event Grid on resize column event.
   */
  public onResize(event: Array<GridResizeEvent>): void
  {
    event.forEach(item =>
    {
      const field = this.columnsConfig.find((col) => col.field === item.column.field);
      if (field !== undefined)
      {
        field.width = item.newWidth;
      }
    });
  }

  /**
   * Reorder grid column order event
   *
   * @param e ColumnReorderEvent event
   */
  public onReorder(e: ColumnReorderEvent): void
  {
    const reorderedColumn = this.columnsConfig.splice(e.oldIndex, 1);
    this.columnsConfig.splice(e.newIndex, 0, ...reorderedColumn);
  }

  public pageChange(event: any): void
  {
    this.state.take = event.take;
  }

  /**
   * Reset grid columns with default state
   */
  public resetGridColumns(): void
  {
    this.columnsConfig = cloneDeep(this.defaultColumnsConfig);
    this.state.take = this.defaultGridState.take;     // Reset just the pagesize from default grid state
    this.refresh();
  }

  public refresh(): void
  {
    this.state.skip = 0;
    this.queryMembers(this.memberListService, this.state);
  }

  private navigateToPatientFHIRFullSite(): void
  {
    /*
      if MPI present but MPI Dictionary not found
         OR
         Patient not found by MPI and also by (last name, first name, dob)
         OR
         multiple patients found with the same conditions
      then stay on /members/all
      else navigate to patient
    */

    const state: State = { skip: 0, take: 5, filter: { logic: 'and', filters: [] } };
    const fullName = this.fhirService.patientContext.firstName || this.fhirService.patientContext.lastName ?
      `${this.fhirService.patientContext.firstName} ${this.fhirService.patientContext.lastName}` : '';

    if (this.fhirService.patientContext.mpi)
    {
      if (!this.subjectIdentifierMPI) 
      {
        this.messageHandlerService.displayError('MPI-DICTIONARY-NOT-FOUND');
        this.sessionStorageService.clear(FHIR_NAVIGATE_TO_PATIENT_SUMMARY);
        return;
      }
      else
      {
        state.filter.filters.push({ field: 'identifierDictionary', operator: 'eq', value: this.subjectIdentifierMPI.id, logic: 'and' });
        state.filter.filters.push({ field: 'identifier', operator: 'eq', value: this.fhirService.patientContext.mpi, logic: 'and' });
      }
    }
    else
      if (fullName)
      {
        state.filter.filters.push({ field: 'fullName', operator: 'eq', value: fullName });
        if (this.fhirService.patientContext.dob)
        {
          state.filter.filters.push({ field: 'dateOfBirth', operator: 'eq', value: this.fhirService.patientContext.dob });
        }
      }
      else
      {
        this.sessionStorageService.clear(FHIR_NAVIGATE_TO_PATIENT_SUMMARY);
        return;
      }

    this.memberListService.queryByState(state, (patient: any) =>
    {
      if (patient !== null && patient.data !== null)
      {
        if (patient.total === 1)
        {
          const memberId = patient.data[0].id;
          this.router.navigate([`/patient/${memberId}`]);
          this.sessionStorageService.clear(FHIR_NAVIGATE_TO_PATIENT_SUMMARY);
        }
        else if ((patient.total > 1) || (patient.total = 1))
        {
          this.sessionStorageService.clear(FHIR_NAVIGATE_TO_PATIENT_SUMMARY);
          return;
        }
      }
    }, null, this.isRestrictedPaging ? '&restrictedPaging=true' : '');
  }

  private getMembers(filter: string): void
  {
    this.isRecentViewContext = filter === 'recent';
    if (filter === 'all' || filter === 'recent')
    {
      this.columnsConfig = cloneDeep(this.defaultColumnsConfig);
      this.state = cloneDeep(this.defaultGridState);

      // Must not use sort to make sure it is sorted by recent
      if (this.isRecentViewContext && this.state.sort) { this.state.sort = []; }

      this.breadcrumb = filter.toLocaleUpperCase();
      delete this.state.filter;
      this.stringLiteralBreadcrumb = false;
      this.queryMembers(this.memberListService, this.state);
    }
    else
    {
      this.filterService.getCachedMemberFilters(this.currentUser.userName).subscribe({
        next: (filterList) =>
        {
          const item = filterList.find(obj => obj.id.toString() === filter.toString());
          this.filterSelected = item;
          this.breadcrumb = item.name;
          this.stringLiteralBreadcrumb = true;
          this.state = JSON.parse(item.state);
          this.columnsConfig = item.columns ? JSON.parse(item.columns) : this.defaultColumnsConfig;

          // reset pagination numbers as we're more concerned with filters and sorting.
          this.state.skip = 0;
          this.queryMembers(this.memberListService, this.state);
        }
      });
    }
  }

  /**
   * Get the list of genders from distionary database.
   */
  private getGenderCodes(): void
  {
    this.dictionaryService.getCachedGenders().subscribe({
      next: data => { this.genders = data; }
    });
  }

  /**
   * Query members by injecting extra query string if this is the recent option.
   *
   * @param listService List service to use for the query.
   * @param state  State for the query.
   */
  private queryMembers(listService: MemberListService, state: State): void
  {
    let queryString = this.isRecentViewContext ? '&recentOnly=true' : '';
    if (this.isRestrictedPaging) { queryString += '&restrictedPaging=true'; }
    listService.queryByState(state, null, queryString);
  }

  private autoFitColumns(): void
  {
    if (this.grid !== undefined && this.autoFitColumnsEnabled)
    {
      setTimeout(() =>
      {
        this.grid.autoFitColumns();
        this.grid.scrollTo({ row: 0, column: 0 });
      });
    }
  }
}
